module.exports = __webpack_public_path__ + "static/media/three-windows.a6e11686.jpg";